import React from 'react';
import Image from './Image';

const Login = () => {
  return (
    <div className="box">
      <div className="box__header">
        KHÔI PHỤC MẬT KHẨU
      </div>
      <div className="box__body">
        <div className="login">
          <div className="login__header">Đăng nhập bằng tài khoản garena để khôi phục mật khẩu</div>
          <div className="login__body">
            <a href="/user/login" className="btn-hover-scale" title="Đăng nhập">
              <Image src="images/btn-login.png"/>
            </a>
          </div>
          <div className="login__footer">
            Trong trường hợp bạn bị mất mật khẩu Garena <br/>
            vui lòng <a href="https://account.garena.com/recovery#/" target="_blank">click vào link này</a> để lấy lại tài khoản
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login;
